/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_cd_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Once the date passes it shows how long ago it was.`)
};

const es_cd_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cuando la fecha pasa, muestra cuánto tiempo hace que ocurrió.`)
};

const de_cd_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sobald das Datum vergangen ist, zeigt es, wie lange es schon her ist.`)
};

const nl_cd_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zodra de datum is verstreken, wordt getoond hoe lang geleden dat was.`)
};

const fr_cd_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Une fois la date passée, il affiche depuis combien de temps c'était.`)
};

const it_cd_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Una volta passata la data, mostra da quanto tempo è successo.`)
};

const pt_br2_cd_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Depois que a data passa, mostra há quanto tempo ela ocorreu.`)
};

const pt_cd_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Assim que a data passa, mostra há quanto tempo foi.`)
};

const ja_cd_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`日付を過ぎると、どれくらい前だったかが表示されます。`)
};

const zh_cd_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`日期过后，会显示距该时刻已经过去了多久。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const cd_ex2 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.cd_ex2(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("cd_ex2", locale)
	if (locale === "en") return en_cd_ex2(inputs)
	if (locale === "es") return es_cd_ex2(inputs)
	if (locale === "de") return de_cd_ex2(inputs)
	if (locale === "nl") return nl_cd_ex2(inputs)
	if (locale === "fr") return fr_cd_ex2(inputs)
	if (locale === "it") return it_cd_ex2(inputs)
	if (locale === "pt-BR") return pt_br2_cd_ex2(inputs)
	if (locale === "pt") return pt_cd_ex2(inputs)
	if (locale === "ja") return ja_cd_ex2(inputs)
	return zh_cd_ex2(inputs)
};